import { Box } from '../Box/Box.js';
import styled from 'styled-components';

var px = 'px';
var transparent = 'transparent';
var positions = ['start', 'start-above', 'start-top', 'start-bottom', 'start-below', 'end', 'end-above', 'end-top', 'end-bottom', 'end-below', 'above', 'below'];

/**
 * Maps the ADS pointer position to a Floating UI placement.
 */
var mapPlacement = function mapPlacement(isRTL, pointerPosition) {
  switch (pointerPosition) {
    case 'start':
      return isRTL ? 'left' : 'right';
    case 'start-top':
      return isRTL ? 'left-start' : 'right-start';
    case 'start-bottom':
      return isRTL ? 'left-end' : 'right-end';
    case 'end':
      return isRTL ? 'right' : 'left';
    case 'end-top':
      return isRTL ? 'right-start' : 'left-start';
    case 'end-bottom':
      return isRTL ? 'right-end' : 'left-end';
    case 'above':
      return 'bottom';
    case 'below':
      return 'top';
    case 'end-above':
      return 'bottom-end';
    case 'end-below':
      return 'top-end';
    case 'start-above':
      return 'bottom-start';
    default:
    case 'start-below':
      return 'top-start';
  }
};
var Pointer = /*#__PURE__*/styled(Box).withConfig({
  displayName: "Pointer",
  componentId: "sc-3gxo1v-0"
})(function (props) {
  var $x = props.$x,
    $y = props.$y,
    $color = props.$color,
    $side = props.$side,
    $size = props.$size,
    $isRTL = props.$isRTL,
    $padding = props.$padding;
  var pointerPositions = $side.split('-');
  var pointerPosition = pointerPositions[0];
  var isHorizontal = pointerPosition === 'left' || pointerPosition === 'right';
  var pointerAlignment = pointerPositions[1];
  if ($isRTL && pointerAlignment && !isHorizontal) {
    pointerAlignment = pointerAlignment === 'start' ? 'end' : 'start';
  }
  var size = $size;
  var x = $x && $x + px;
  var y = $y && $y + px;
  var negativePadding = "-".concat($size);
  var top;
  var right;
  var bottom;
  var left;
  if (isHorizontal && pointerAlignment !== 'end') {
    top = pointerAlignment === 'start' ? $padding : y;
  } else if (pointerPosition === 'bottom') {
    top = negativePadding;
  }
  if (!isHorizontal && pointerAlignment === 'end') {
    right = $padding;
  } else if (pointerPosition === 'left') {
    right = negativePadding;
  }
  if (isHorizontal && pointerAlignment === 'end') {
    bottom = $padding;
  } else if (pointerPosition === 'top') {
    bottom = negativePadding;
  }
  if (!isHorizontal && pointerAlignment !== 'end') {
    left = pointerAlignment === 'start' ? $padding : x;
  } else if (pointerPosition === 'right') {
    left = negativePadding;
  }
  return {
    top: top,
    right: right,
    bottom: bottom,
    left: left,
    position: 'absolute',
    height: 0,
    width: 0,
    borderStyle: 'solid',
    borderTopWidth: pointerPosition === 'bottom' ? '0' : size,
    borderRightWidth: pointerPosition === 'left' ? '0' : size,
    borderBottomWidth: pointerPosition === 'top' ? '0' : size,
    borderLeftWidth: pointerPosition === 'right' ? '0' : size,
    borderTopColor: pointerPosition === 'top' ? $color : transparent,
    borderRightColor: pointerPosition === 'right' ? $color : transparent,
    borderBottomColor: pointerPosition === 'bottom' ? $color : transparent,
    borderLeftColor: pointerPosition === 'left' ? $color : transparent
  };
});

export { Pointer, mapPlacement, positions };
//# sourceMappingURL=Pointer.js.map
